/* unplugin-vue-components disabled */import script from "./ChatCell.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatCell.vue?vue&type=script&setup=true&lang=js"

import "./ChatCell.vue?vue&type=style&index=0&id=0089145a&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0089145a"]])

export default __exports__